module.exports = __webpack_public_path__ + "files/b76e6bce849592178fcb0b7e9ee902f1.png";